import { Directive, ElementRef, Renderer, Input, HostListener } from '@angular/core';

@Directive( {
    selector: '[auto-select]'
})
export class AutoSelectDirective {

    constructor( element: ElementRef ) {
    }

    @HostListener('focus', ['$event.target'])
    private onFocus(target: any) {
        if (target != null)
            target.select();
    }
}